export class RszValidators {
  static stringPattern = new RegExp(/^[^?<>;=+&]+$/);
  static yearPattern = new RegExp(/^[12][0-9]{3}$/);
  static emailPattern = new RegExp(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
  static phonePattern = new RegExp(/^[+]([0-9+]{7,20}$)$/);
  //should contain upper and lowercase char, number
  static passwordPattern = new RegExp(
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/
  );

  data = null;

  constructor(data) {
    this.data = data;
  }

  get validateString() {
    return this.stringPattern.test(this.data);
  }

  get validateYear() {
    return this.yearPattern.test(this.data);
  }

  get validateEmail() {
    return this.emailPattern.test(this.data);
  }

  get validatePhone() {
    return this.phonePattern.test(this.data);
  }

  get validatePassword() {
    return this.passwordPattern.test(this.data);
  }

  setData(value) {
    this.data = value;
  }
}
